'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';

const SPLASH_KEY = 'winewood_splash_shown';

export default function SplashScreen() {
  const [visible, setVisible] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem(SPLASH_KEY);
    if (!alreadyShown) {
      setVisible(true);
      sessionStorage.setItem(SPLASH_KEY, '1');
      // Start fade-out after 2s
      const fadeTimer = setTimeout(() => {
        setAnimateOut(true);
      }, 2000);
      // Remove from DOM after animation completes
      const removeTimer = setTimeout(() => {
        setVisible(false);
      }, 2700);
      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(removeTimer);
      };
    }
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center"
      style={{
        background: 'var(--background)',
        transition: 'opacity 0.7s ease',
        opacity: animateOut ? 0 : 1,
        pointerEvents: animateOut ? 'none' : 'all',
      }}>
      <div
        style={{
          transform: animateOut ? 'scale(1.05)' : 'scale(1)',
          transition: 'transform 0.7s ease',
          animation: !animateOut ? 'splashIn 0.6s cubic-bezier(0.34,1.56,0.64,1) forwards' : undefined,
        }}>
        <Image
          src="/assets/images/logo_grun_fur_app-1787922846254.png"
          alt="WINEWOOD Adventure"
          width={220}
          height={88}
          className="object-contain"
          priority
        />
      </div>
      <p
        className="mt-4 text-xs font-medium tracking-widest uppercase"
        style={{
          color: 'var(--muted-foreground)',
          opacity: animateOut ? 0 : 1,
          transition: 'opacity 0.5s ease 0.2s',
          animation: !animateOut ? 'splashTextIn 0.6s ease 0.3s both' : undefined,
        }}>
        Dein Standort. Dein Abenteuer.
      </p>
      <style>{`
        @keyframes splashIn {
          from { opacity: 0; transform: scale(0.8); }
          to   { opacity: 1; transform: scale(1); }
        }
        @keyframes splashTextIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
